// src/components/CitizenImpactCards.js
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './CitizenImpactCards.css';

const CitizenImpactOutlineCard = ({ logoSrc, title, value, bgColor, infoText }) => {
  return (
    <div
      className="citizenimpact-outline-card"
      style={{ backgroundColor: bgColor }}
    >
      <div className="citizenimpact-card-header">
        <img src={logoSrc} alt="Logo" className="citizenimpact-logo" />
        <h3>
          {title}
          <span className="info-wrapper">
            <span className="info-icon">i</span>
            <div className="tooltip">{infoText}</div>
          </span>
        </h3>
      </div>

      <div className="citizenimpact-card-content">
        <p>
          <strong>{value}</strong>
        </p>
      </div>
    </div>
  );
};

const formatNumber = (num) => {
  return new Intl.NumberFormat().format(num);
};

const CitizenImpactCards = () => {
  const [citizenImpactValues, setCitizenImpactValues] = useState({
    applications_submitted: '',
    citizen_impacted: '',
    msmes_impacted: '',
    hds_trained: '',
    benefits_unblocked: ''
  });

  const fetchData = async () => {
    try {
      const response = await axios.post(
        "https://api-sales-insights.haqdarshak.com/landing-page-cards"
      );

      const data = response.data;

      setCitizenImpactValues({
        applications_submitted: formatNumber(data.Total_App_Submitted || 0),
        citizen_impacted: formatNumber(data.DFL_Unique_citizens || 0),
        msmes_impacted: formatNumber(data.Total_Citz_reached || 0),
        hds_trained: formatNumber(data.Num_of_hd_Trained || 0),
        benefits_unblocked:
          formatNumber((data.Total_BV_Received / 10000000).toFixed(2)) +
          " crore"
      });

    } catch (error) {
      console.error("Error fetching API data:", error);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <div>
      <div className="citizenimpact-card-container">

        <CitizenImpactOutlineCard
          logoSrc="/Citizen_Impacted.jpg"
          title="DFL Trained Individuals"
          value={citizenImpactValues.citizen_impacted}
          bgColor="var(--citizen-impacted-color)"
          infoText='Individuals trained on digital and financial literacy since April’23'
        />

        <CitizenImpactOutlineCard
          logoSrc="/Application_Submitted.jpg"
          title="Applications Submitted"
          value={citizenImpactValues.applications_submitted}
          bgColor="var(--applications-submitted-color)"
          infoText='Total number of schemes where the application has reached the "Document Submitted" status.'
        />

        <CitizenImpactOutlineCard
          logoSrc="/MSMEs_Impacted.jpg"
          title="Citizens Reached"
          value={citizenImpactValues.msmes_impacted}
          bgColor="var(--msmes-impacted-color)"
          infoText='Total number of unique citizens that have been reached or screened.'
        />

        <CitizenImpactOutlineCard
          logoSrc="/HDs_Trained.jpg"
          title="HDs Trained"
          value={citizenImpactValues.hds_trained}
          bgColor="var(--hds-trained-color)"
          infoText="Total number of HD's who have been trained or onboarded."
        />

        <CitizenImpactOutlineCard
          logoSrc="/Benefits_Unblocked.jpg"
          title="Benefits Unlocked"
          value={citizenImpactValues.benefits_unblocked}
          bgColor="var(--benefits-unblocked-color)"
          infoText="The total value of benefits unlocked."
        />

      </div>
    </div>
  );
};

export default CitizenImpactCards;